const Resume = () => {
  return (
    <>
      {/* <div className="resume" id="resume">
            <h1 className="resume-title">My Resume</h1>
            <div className="pdf">
            <iframe
            title="Aman_Resume"
               frameBorder="0"
               scrolling="no"
               width="640"
               height="480"
            src='../AmanVerma_Resume.pdf' 
            >
            </iframe>

            <a href="../AmanVerma_Resume.pdf" download target="_blank" className="resume_btn">Download Resume</a>
            </div>
            </div> */}
      <div className="sec">
        <section id="resume" className="resume section-show">
          <div className="container">
            <div className="section-title">
              <h2>Resume</h2>
              <p>Check My Resume</p>
            </div>

            <div className="rrow">
              <div className="rleft">
                <h3 className="resume-title">Sumary</h3>
                <div className="resume-item pb-0">
                  <h4>Aman Verma</h4>
                  <p>
                    <em>
                      Full Stack Web Developer with a passion for
                      problem-solving while Combining technical expertise with a
                      creative mindset, creating innovative solutions that
                      enhance user experiences.
                    </em>
                  </p>
                  <ul>
                    <li>Jharkhand, India</li>
                    <li>(+91) 7070870833</li>
                    <li>amanvermabitd@gmail.com</li>
                  </ul>
                </div>

                <h3 className="resume-title">Education</h3>
                <div className="resume-item">
                  <h4>Bachelor of Engineering &amp; Techonology</h4>
                  <h5>2020 - 2024 &nbsp;  CGPA-8.01</h5>
                  <p>
                    <em>Birla Institute of Technology, Mesra</em>
                  </p>
                  {/* <p>Qui deserunt veniam. Et sed aliquam labore tempore sed quisquam iusto autem sit. Ea vero voluptatum qui ut dignissimos deleniti nerada porti sand markend</p> */}
                </div>
                <div className="resume-item">
                  <h4>Higher Secondary</h4>
                  <h5>2019 - 2020 &nbsp; Percentage-89.6%</h5>
                  <p>
                    <em>Jamshedpur Public School, Jamshedpur</em>
                  </p>
                  {/* <p>Quia nobis sequi est occaecati aut. Repudiandae et iusto quae reiciendis et quis Eius vel ratione eius unde vitae rerum voluptates asperiores voluptatem Earum molestiae consequatur neque etlon sader mart dila</p> */}
                </div>
                <div className="resume-item">
                  <h4>Matriculation</h4>
                  <h5>2017 - 2018 &nbsp; Percentage-86.4%</h5>
                  <p>
                    <em>Jamshedpur Public School, Jamshedpur</em>
                  </p>
                  {/* <p>Quia nobis sequi est occaecati aut. Repudiandae et iusto quae reiciendis et quis Eius vel ratione eius unde vitae rerum voluptates asperiores voluptatem Earum molestiae consequatur neque etlon sader mart dila</p> */}
                </div>
              </div>
              <div className="rright">
                <h3 className="resume-title">Professional Experience</h3>
                <div className="resume-item">
                  <h4>TATA STEEL Ltd</h4>
                  <h5>Summer Intern &nbsp;  05/2023 - 07,2023</h5>
                  <p>
                    <em>Jamshedpur, India </em>
                  </p>
                  <p>
                    <ul>
                      <li>
                        Designed & Developed a Full-Stack Project "Smart
                        Material Gatepass System".
                      </li>
                      <li>
                        Automated the functionality to generate E-Verified
                        Gate-Passes through the system, reducing the process
                        time spent by 60%.
                      </li>
                      <li>
                        Enhanced security by digitizing the authorization
                        process and providing real-time tracking of materials.
                      </li>
                      <li>
                        Technologies Used: Node, Express, EJS templating Engine,
                        JWT Tokens, Firebase (for Dtatabase).
                      </li>
                    </ul>
                  </p>
                </div>
                <div className="resume-item">
                  <h4>Designkoktail Pvt Ltd.</h4>
                  <h5>Full-Stack Developer Intern &nbsp; 11,2022 - 03,2023</h5>
                  <p>
                    <em>Work From Home</em>
                  </p>
                  <p>
                    <ul>
                      <li>
                        Developed a web-based platform named "Karigars-India"
                        which bridges the gap between Labours & Employers.
                      </li>
                      <li>
                        Used the MVC framework, ensuring efficient code
                        organization and maintainability within the team.
                      </li>
                      <li>
                        Worked with JWT Tokens and cookies for managing user
                        sessions securely.
                      </li>
                      <li>
                        Used Node.js and Express.js as the backend technologies.{" "}
                      </li>
                    </ul>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="main">
            {/* <div className="section-title" style={{ textAlign:"left" }}>
              <h2 style={{ color: "white", textAlign: "left" }}>
                Volunteering
              </h2>
              <p style={{ color: "white", textAlign: "left" }}>
                Position of Responsiblity
              </p>
            </div> */}
            <div className="testimonials">
              <input
                type="radio"
                name="testimonial"
                id="input-testimonial1"
                defaultChecked
              />
              <input type="radio" name="testimonial" id="input-testimonial2" />
              <input type="radio" name="testimonial" id="input-testimonial3" />
              <input type="radio" name="testimonial" id="input-testimonial4" />
              <div className="testimonials-inner">
                <div className="testimonial">
                  <div className="testimonial-photo">
                    <div className="photo-background"></div>
                    <div className="photo-author"></div>
                  </div>
                  <div className="testimonial-text">
                    <div className="testimonial-author">
                      <strong>Technical Team Lead</strong>
                    </div>
                    <div className="testimonial-authorr">
                      Google Developers Student Clubs
                    </div>
                    <p>
                      Coordinated with a team of 30+ members and conducted
                      various events, webinars and competitions. with student
                      coordinators that support the goals of the Club.
                    </p>
                  </div>
                </div>
                <div className="testimonial">
                  <div className="testimonial-photo">
                    <div className="photo-background"></div>
                    <div className="photo-author"></div>
                  </div>
                  <div className="testimonial-text">
                    <div className="testimonial-author">
                      <strong>Social Media Lead</strong>
                    </div>
                    <div className="testimonial-authorr">Geeksforgeeks</div>
                    <p>
                      Managed the team to maintain various social media
                      platforms for the club .
                    </p>
                  </div>
                </div>
                <div className="testimonial">
                  <div className="testimonial-photo">
                    <div className="photo-background"></div>
                    <div className="photo-author"></div>
                  </div>
                  <div className="testimonial-text">
                    <div className="testimonial-author">
                      <strong>Web Developer Mentor</strong>
                    </div>
                    <div className="testimonial-authorr">
                      Google Developers Student Clubs
                    </div>
                    <p>
                      Mentored and provided technical guidance to student
                      developers on web development projects.
                    </p>
                  </div>
                </div>
                <div className="testimonial">
                  <div className="testimonial-photo">
                    <div className="photo-background"></div>
                    <div className="photo-author"></div>
                  </div>
                  <div className="testimonial-text">
                    <div className="testimonial-author">
                      <strong>Student Coordinator</strong>
                    </div>
                    <div className="testimonial-authorr">Dristi, NGO</div>
                    <p>
                      Coordinated and volunteered in various Social Service
                      projects, including free Tutoring students, and plantation
                      activities.
                    </p>
                  </div>
                </div>
              </div>
              <div className="testimonials-arrows">
                <div className="arrow arrow-left">
                  <label htmlFor="input-testimonial1"></label>
                  <label htmlFor="input-testimonial2"></label>
                  <label htmlFor="input-testimonial3"></label>
                  <label htmlFor="input-testimonial4"></label>
                  <span></span>
                </div>
                <div className="arrow arrow-right">
                  <label htmlFor="input-testimonial1"></label>
                  <label htmlFor="input-testimonial2"></label>
                  <label htmlFor="input-testimonial3"></label>
                  <label htmlFor="input-testimonial4"></label>
                  <span></span>
                </div>
              </div>
              <div className="testimonials-bullets">
                <label htmlFor="input-testimonial1">
                  <div className="bullet">
                    <div>
                      <span></span>
                    </div>
                  </div>
                </label>
                <label htmlFor="input-testimonial2">
                  <div className="bullet">
                    <div>
                      <span></span>
                    </div>
                  </div>
                </label>
                <label htmlFor="input-testimonial3">
                  <div className="bullet">
                    <div>
                      <span></span>
                    </div>
                  </div>
                </label>
                <label htmlFor="input-testimonial4">
                  <div className="bullet">
                    <div>
                      <span></span>
                    </div>
                  </div>
                </label>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};
export default Resume;
